import React from 'react';
import RadioFields from '../fields/RadioFields';
import InfoTooltip from '../tooltips/InfoTooltip';
import {useSelector} from 'react-redux';
import useFieldRules from '../../hooks/useFieldRules';
import useSyncedField from '../../hooks/useSyncedField';
import Tooltips from '../../helpers/fieldTooltips';

function Spacing() {
    const options = useSelector(state => state.orderOptions.data.spacing);

    const {isVisible} = useFieldRules('spacing');
    useSyncedField('spacing', 'int');

    if (!isVisible) return null;

    return (
        <div className="form-group form-control-spacing">
            <div className="form-label d-flex">
                Page Spacing
                <InfoTooltip>
                    <p>{Tooltips.spacing}</p>
                </InfoTooltip>
            </div>
            <RadioFields
                name="spacing"
                options={options}
                parse={value => parseInt(value, 10)}
            />
        </div>
    );
}

export default Spacing;
